export default "__VITE_ASSET__D6oxSOhi__"